import React, { useState, useEffect } from 'react'

interface SlideshowProps {
  images: string[]
  interval?: number
  startDelay?: number
  startIndex?: number
}

const Slideshow: React.FC<SlideshowProps> = ({
  images,
  interval = 600,
  startDelay = 5000,
  startIndex = 0,
}) => {
  const [currentIndex, setCurrentIndex] = useState(() => Math.min(startIndex, images.length - 1))

  useEffect(() => {
    if (images.length <= 1) return

    let intervalId: number | null = null

    const timeoutId = window.setTimeout(() => {
      intervalId = window.setInterval(() => {
        setCurrentIndex((prev) => (prev + 1) % images.length)
      }, interval)
    }, startDelay)

    return () => {
      clearTimeout(timeoutId)
      if (intervalId !== null) {
        clearInterval(intervalId)
      }
    }
  }, [images.length, interval, startDelay])

  return (
    // <div className='my-30'>
    <div className='relative w-full overflow-hidden rounded-sm aspect-2/2 px-3'>
      <img
        src={images[currentIndex]}
        alt={`Slide ${currentIndex + 1}`}
        className='w-full h-full object-contain transition-opacity duration-500'
      />
    </div>
    // <p className='text-center text-2xl'>#StopHumanSafari</p>
    // </div>
  )
}

export default Slideshow
